module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 95"><path class="st0" d="M93 8.5v27.8h-4.6V16.5L53.1 51.7l-3.3-3.3 35.3-35.3H65.6V8.5H93zm-4.6 41.6V87H14.6V13.2h36.9V8.5H9.9v83.1H93V50.1h-4.6z" stroke="#000" stroke-width="2" stroke-miterlimit="10"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/share.svg
// module id = 562
// module chunks = 1